import { render } from "./PaymentButton.vue?vue&type=template&id=ac9ef666&scoped=true"
import script from "./PaymentButton.vue?vue&type=script&lang=js"
export * from "./PaymentButton.vue?vue&type=script&lang=js"

import "./PaymentButton.vue?vue&type=style&index=0&id=ac9ef666&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac9ef666"]])

export default __exports__